import styled from "styled-components";

export const DadosSolicitacaoContainer = styled.div`
  max-width: 100%;

  overflow: hidden;
  border-radius: 4px;
`;

export const Header = styled.div`
  color: #fff;
  font-weight: bold;

  font-size: 20px;
  padding: 16px;

  background-color: ${({ color }) => color};
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: -6px;
  z-index: 2;
  @media (max-width: 768px) {
    span {
      display: block;
      margin-top: 4px;
    }
  }
`;

export const Body = styled(Header)`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  border: 1px solid #b1b3b3;
  border-top: 0;
  border-radius: 0px 0px 8px 8px;
`;

export const Cabecalho = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ItemCabecalho = styled.div`
  width: 48%;
  // width: calc(100% / 3);
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  // margin: 8px 0;
  position: relative;

  .container {
    border-bottom: 2px solid #848484;
    width: 90%;
    align-items: flex-start;
    height: 50px;
  }
  span {
    color: #848484;
    font-size: 12px;
    &:last-child {
      font-weight: bold;
      margin-top: 4px;
    }
  }
  .cabecalhoIcon {
    position: absolute;
    top: 10px;
    right: 0;
    border-radius: 4px;
    background-color: ${({ tema }) => tema.primaryColorFade};
    svg {
      fill: ${({ tema }) => tema.primaryColor};
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 16px;
    padding-bottom: 4px;
    span {
      &:last-child {
        margin-top: 4px;
      }
    }
  }
`;

export const AssuntoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  p,
  span {
    color: #848484;
    font-size: 12px;
  }
  p {
    max-width: 100%;
    padding: 16px 8px;
    border: 2px solid #848484;
    border-radius: 4px;
  }
  @media (max-width: 768px) {
    margin-top: 8px;
  }
`;

export const Footer = styled.div`
  margin-bottom: 40px;
  details {
    div {
      border: 1px solid #b1b3b3;
      padding: 16px;
      border-top-width: 0;
      margin-top: -5px;
      box-sizing: border-box;
    }
    summary {
      color: #fff;
      font-weight: bold;

      font-size: 20px;
      padding: 16px;
      cursor: pointer;
      max-height: 62px;
      background-color: ${({ tema }) => tema?.primaryColor};
      box-sizing: border-box;
      border-radius: 8px;
    }
  }
  p {
    margin: 8px 0;
    font-size: 12px;
    color: #848484;
  }
`;

export const Title = styled.h1`
  font-size: 22px;
  color: #444444;
  font-weight: bold;

  span {
    text-transform: capitalize;
  }
  @media (max-width: 768px) {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    span {
      margin: 2px 0;
    }
    small {
      display: none;
    }
  }
`;

export const MsgAvisoAssistenciaTecnica = styled.div`
  border: 2px solid #4d4d4d;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 24px;

  .title-messageAT {
    font-size: 16px;
    color: rgb(186, 18, 43);
    font-weight: bold;
    text-align: center;
    display: block;
    margin-bottom: 6px;
  }

  .messageAT {
    font-size: 16px;
    color: #4d4d4d;
    font-weight: bold;
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 16px;

    .messageAT {
      text-align: center;
    }
  }
`;
